<template>
	<div id="users" class="bgColor rounded-t-xl" style="height: 90vh">
		<!-- delete dialog -->
		<bee-delete-dialog
			v-model="deleteDialog"
			moduleType="users"
			:ids="userIdDelete"
			@on-delete="fetchAll"
		>
			{{$t('do-you-want-to')}} 
			<span class="text-uppercase error--text">{{$t('delete') +'  '+ getUserById(userIdDelete)?.name + '؟'}}</span>
		</bee-delete-dialog>

		<!-- dialog -->
		<v-dialog v-model="dialog" width="400px">
			<v-card>
				<v-form @submit.prevent="accountStatusChange()">
					<v-card-title class="py-1">
						<v-spacer/>
						<span
							:class="userActivatedId !== null ?  
								getUserById(userActivatedId).isActive ? 
								'alert-color--text' : 
							'primary--text' :
							'' "
						> 
							{{ $t('Users.edit-account-status')}}
						</span>
						<v-spacer/>
						<v-btn icon dark @click="dialog = false">
							<v-icon small :color="userActivatedId !== null ?  getUserById(userActivatedId).isActive ? 'alert-color' : 'primary' : '' ">
								mdi-close
							</v-icon>
						</v-btn>
					</v-card-title>
					<v-divider class="mx-4" />
					<v-card-text class="pt-3">
						{{ 
							userActivatedId !== null ? 
							getUserById(userActivatedId).isActive ? 
								$t('Users.are-you-sure-to-deactivate-an-account') 
								: $t('Users.are-you-sure-to-activate-an-account') 
							: '' 
						}} 
						{{
							userActivatedId !== null ? 
							getUserById(userActivatedId).name
							: '' 
						}}
						؟ 
					</v-card-text>

					<v-card-actions class="justify-end">
						<v-btn
							type="submit"
							:loading="loading"
							:disabled="loading"
							:color="userActivatedId !== null ? 
								getUserById(userActivatedId).isActive ? 
								'alert-color white--text'
								:'primary' 
							: '' "
							>
							{{$t('ok')}}
						</v-btn>
						<v-btn text @click="dialog = false" :disabled="loading"> {{$t('cancel')}} </v-btn>
					</v-card-actions>
				</v-form>
			</v-card>
		</v-dialog>

		<!-- dialog power-->
		<v-dialog v-model="dialogPower" width="700px">
			<v-card>
				<v-card-title class="py-1">
					<v-spacer/>
					<span class="primary--text"> 
						{{ userId !== null ? $t('Users.user-edit') : $t('Users.user-create') }}
					</span>
					<v-spacer/>
					<v-btn
						icon
						dark
						@click="dialogPower = false"
						class="d-flex justify-end"
					>	
						<v-icon small color="primary" @click="userId = null">
							mdi-close
						</v-icon>
					</v-btn>
				</v-card-title>

				<v-divider class="mx-4" />
				<!-- info user -->
				<v-form ref="form">
					<v-card-text class="pt-3">
						<v-row>
							<v-col cols="12" class="pb-0"> 
								<p class="mb-0">
									{{$t('Users.user-info')}}	
								</p>
							</v-col>
							<v-col>
								<v-text-field
									v-model="submitData.name"
									:label="$t('forms.name')"
									outlined
									dense
									hide-details="auto"
									:rules="rules.required"
								/>	
							</v-col>

							<v-col>
								<v-text-field
									v-model="submitData.username"
									:label="$t('forms.user-name')"
									outlined
									dense
									hide-details="auto"
								/>
							</v-col>
						</v-row>

						<!-- password -->
						<v-row>
							<v-col>
								<v-text-field
									v-model="submitData.password"
									:type="showPassword ? 'text' : 'password'"
									:append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
									@click:append="showPassword = !showPassword"
									:label="$t('forms.password')"
									:placeholder="userId ? $t('Users.optional') : ''"
									outlined
									dense
									:rules="userId ? [] : rules.password"
									hide-details="auto"
								/>					
							</v-col>
							<v-col>
								<!-- :rules="userId ? [] : rules.password" -->
								<v-text-field
									v-model="submitData.confirmPassword"
									:type="showConfirmPassword ? 'text' : 'password'"
									:append-icon="showConfirmPassword ? 'mdi-eye' : 'mdi-eye-off'"
									@click:append="showConfirmPassword = !showConfirmPassword"
									:label="$t('forms.confirmPassword')"
									:placeholder="userId ? $t('Users.optional') : ''"
									outlined
									dense
									:rules="submitData.password && userId === null ? [val => val === submitData.password || $t('messages.not-matched-password')] : []"
									hide-details="auto"
								/>
							</v-col>
						</v-row>

						<v-divider class="mt-4 mb-2"/>

						<!-- power (permations) -->
						<!--added the map for the entires to add a fake id to the elements to make the table work properly-->
						<p>{{$t('Users.user-power')}}</p>
						<bee-handy-smart-table
							v-model="tableInput"
							ref="table"
							:headers="headersSmart"
							:items="entries.map((v, index) => ({...v, id: index}))"
							:items-per-page="-1"
							show-add-row
							stay-in-input-fields
							:loading="loadingPermissions"
							:data-table-props="{
								disableSort: true,
								noDataText: $t('entery-value-and-prass-enter')
							}"
							dense
							:editable-rows="!loadingPermissions"
							:disable-input-fields="loadingPermissions"
							@edit-cancelled="isEditItem = false"
							@keypress.enter="!isEditItem ? addItem() : editItem()"
							hide-default-footer
							@context-menu-edit="setRowIndex"
							class="mb-3"
							:validation-messages.sync="validationMessages"
						>	
							<template v-slot:item.actions="{ index }">
								<div class="d-flex">
									<!-- permissions -->
									<v-btn
										icon
										small
										color="primary"
										:disabled="loadingPermissions"
										@click="
											permissionsDialog = true;
											permissionStoreIndex = index;
										"

									>
										<v-icon>mdi-account-cog</v-icon>
									</v-btn>

									<!-- edit -->
									<v-btn
										icon
										small
										color="edit-color"
										:disabled="loadingPermissions"
										class="mx-1"
										@click="$refs.table.activeEditForRow(index); setRowIndex({ index })"
									>
										<v-icon>mdi-pencil</v-icon>
									</v-btn>

									<!-- delete -->
									<v-btn
										icon
										small
										color="alert-color"
										:disabled="loadingPermissions"
										@click="deleteItem({ index })"
									>
										<v-icon>mdi-delete</v-icon>
									</v-btn>
								</div>
							</template>					
							<!-- storeId -->
							<template v-slot:input.storeId="{ on, attr }">
								<v-autocomplete
									:items="stores"
									item-value="id"
									item-text="name"
									auto-select-first
									v-on="on"
									v-bind="attr"
									hide-details
								></v-autocomplete>
							</template>

							<template v-slot:input.userType="{ on, attr }">
								<v-autocomplete
									:items="powersArray"
									item-text="name"
									item-value="id"
									dense
									v-on="on"
									v-bind="attr"
									hide-details
								/>
							</template>

							<template v-slot:input.cashboxId="{ on, attr }">
								<v-autocomplete
									:items="cashboxSystem.filter(c => c.storeId === tableInput.storeId)"
									item-text="name"
									item-value="id"
									dense
									hide-details
									v-on="on"
									v-bind="attr"
								/>
							</template>
							<template v-slot:no-input.actions="{}">
								<div class="d-flex justify-center">
									<v-btn
										text 
										small
										color="green"
										:disabled="loadingPermissions"
										@click="!isEditItem ? addItem() : editItem()"
									>
										<v-icon>mdi-content-save-outline</v-icon>
									</v-btn>
								</div>
							</template>
						</bee-handy-smart-table>
					</v-card-text>

					<v-card-actions >
						<v-spacer />	
						<v-btn
							color="primary"
							:loading="loading"
							:disabled="loading"
							@click="submit"
						> 
							{{$t('save')}}
						</v-btn>
						<v-btn
							color="alert-color white--text"
							@click="dialogPower = false"
							:disabled="loading"
						> 
							{{$t('cancel')}} 
						</v-btn>
					</v-card-actions>
				</v-form>
			</v-card>
		</v-dialog>

		<!-- permissions -->
		<v-dialog
			content-class="permissions-dialog"
			v-model="permissionsDialog"
			max-width="600"
		>
			<v-card>
				<v-card-title class="py-1">
					<v-spacer/>
					<span class="primary--text"> 
						{{$t('Users.user-permissions-for')}}
						({{
							permissionStoreIndex >= 0 && entries[permissionStoreIndex]
								? getStoreById(entries[permissionStoreIndex].storeId)?.name
								: null
						}})
					</span>
					<v-spacer/>
					<v-btn
						icon
						dark
						class="d-flex justify-end"
						@click="permissionsDialog = false"
					>
						<v-icon small color="primary" @click="permissionStoreIndex = null">
							mdi-close
						</v-icon>
					</v-btn>
				</v-card-title>
				<v-card-text v-if="typeof permissionStoreIndex === 'number'">
					<!-- permissions -->
					<v-simple-table
						dense
						fixed-header
						:height="386"
						class="elevation-2"
					>
						<thead>
							<tr>
								<th class="px-2">
									{{$t('Users.permissions.permission-type')}}
								</th>
								<th
									v-if="entries[permissionStoreIndex].userType !== userType.dataReader"
									class="text-center px-0 permission-toggle"
									@click="setAllPermissionsValue(actionType.readAndWrite, permissionStoreIndex)"
								>
									{{$t('Users.permissions.allowed')}}
									<v-icon small>
										{{
											entries[permissionStoreIndex].permissions
												.every(c => c.value === actionType.readAndWrite)
												? 'mdi-checkbox-marked-circle-outline'
												: 'mdi-radiobox-blank'
										}}
									</v-icon>
								</th>
								<th
									class="text-center px-0 permission-toggle"
									@click="setAllPermissionsValue(actionType.none, permissionStoreIndex)"
								>
									{{$t('Users.permissions.not-Allowed')}}
									<v-icon small>
										{{
											entries[permissionStoreIndex].permissions
												.every(c => c.value === actionType.none)
												? 'mdi-checkbox-marked-circle-outline'
												: 'mdi-radiobox-blank'
										}}
									</v-icon>
								</th>
								<th
									class="text-center px-0 permission-toggle"
									@click="setAllPermissionsValue(actionType.read, permissionStoreIndex)"
								>
									{{$t('Users.permissions.read')}}
									<v-icon small>
										{{
											entries[permissionStoreIndex].permissions
												.filter(c => !noReadonlyPermissions.includes(c.permissionType))
												.every(c => c.value === actionType.read)
												? 'mdi-checkbox-marked-circle-outline'
												: 'mdi-radiobox-blank'
										}}
									</v-icon>
								</th>
								<th v-if="false" class="px-2"></th>
							</tr>
						</thead>
						<tbody>
							<tr
								v-for="(permission, i) in permissions"
								:key="i"
							>
								<td class="px-2" style="width: 300px">{{ permission.name }} {{permission.value}}</td>

								<!-- read-and-write -->
								<td
									v-if="entries[permissionStoreIndex].userType !== userType.dataReader"
									class="px-0"
									style="width: 100px"
								>
									<v-checkbox
										v-model="entries[permissionStoreIndex].permissions[i].value"
										:ripple="false"
										:true-value="actionType.readAndWrite"
										:false-value="null"
										class="ma-0"
										dense
										hide-details
										on-icon="mdi-checkbox-marked-circle-outline"
										off-icon="mdi-radiobox-blank"
									/>
								</td>
								
								<!-- no-permission -->
								<td class="px-0" style="width: 120px">
									<v-checkbox
										v-model="entries[permissionStoreIndex].permissions[i].value"
										:ripple="false"
										:true-value="actionType.none"
										:false-value="null"
										class="ma-0"
										dense
										hide-details
										on-icon="mdi-checkbox-marked-circle-outline"
										off-icon="mdi-radiobox-blank"
									/>
								</td>

								<!-- read-only -->
								<td class="px-0" style="width: 100px">
									<v-checkbox
										v-if="!permission.noReadonly"
										v-model="entries[permissionStoreIndex].permissions[i].value"
										:ripple="false"
										:true-value="actionType.read"
										:false-value="null"
										class="ma-0"
										dense
										hide-details
										on-icon="mdi-checkbox-marked-circle-outline"
										off-icon="mdi-radiobox-blank"
									/>
								</td>

								<!-- info -->
								<td v-if="false" class="text-end px-2" style="width: 40px">
									<v-tooltip top color="grey darken-2" open-delay="500">
										<template v-slot:activator="{ attr, on }">
											<v-icon v-on="on" v-bind="attr">mdi-information-outline</v-icon>
										</template>
										{{permission.info}}
									</v-tooltip>
								</td>
							</tr>
						</tbody>
					</v-simple-table>
				</v-card-text>
				<v-card-actions>
					<v-spacer />	
					<v-btn
						color="primary"
						@click="permissionsDialog = false"
					> 
						{{$t('ok')}}
					</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>

		<!-- button -->
		<v-row v-if="!isReadonly" justify="start" class="px-3">
			<v-col class="d-flex justify-end">
				<v-btn color="primary" @click="dialogPower = true">
					<v-icon class="me-1">mdi-file-document-plus-outline</v-icon>
					{{$t('Users.user-create')}}
				</v-btn>
			</v-col>
		</v-row>

		<!-- table -->
        <bee-handy-table
			:headers="headers"
			:items="users"
			:items-per-page="30"
			class="my-3 px-3"
			dense
			zebra
			:loading="loading"
			fixed-header
			pagination-on-scroll
			:height="$vuetify.breakpoint.height - 160"
			:shown-rows-text="$t('shown-rows')"
        >
			<!-- status account -->
			<template v-slot:item.isActive="{ item }">
				<v-chip :color="item.isActive ? 'success' : 'alert-color white--text' " small>
					{{ item.isActive ? $t('Users.active') : $t('Users.stopped') }}
				</v-chip>
			</template>

			<!-- permissions -->
			<template v-slot:item.permissions="{ item }">
				<v-chip-group column>
					<v-chip
						v-for="(c, i) in item.permissions"
						:key="i"
						small
						class="my-1 ms-0 me-1"
					>
						{{getStoreById(c.storeId)?.name}} / {{userTypes.find(e => e.id === c.userType)?.name}}
					</v-chip>
				</v-chip-group>
				<span v-if="!item.permissions.length">-</span>
			</template>

			<!-- actions -->
			<template v-slot:item.actions="{ item }">
				<v-btn
					text
					small
					icon
					:disabled="item.isAdmin"
					color="primary"
					@click="dialog = true; userActivatedId = item.id"
				>
					<v-icon> mdi-account-reactivate</v-icon>
				</v-btn>

				<v-btn
					text
					small
					icon
					:disabled="item.isAdmin"
					color="edit-color"
					class="mx-2"
					@click="userId = item.id; dialogPower = true; fetchUserPermissions(userId)"
				>
					<v-icon>mdi-pencil</v-icon>
				</v-btn>

				<v-btn
					text
					small
					icon
					:disabled="item.isAdmin"
					color="alert-color"
					@click="userIdDelete = item.id; deleteDialog = true"
				>
					<v-icon>mdi-delete</v-icon>
				</v-btn>
			</template>
		</bee-handy-table>
    </div>
</template>

<script>
import rules from '@/helpers/validation rules'
import { mapState, mapGetters } from 'vuex'
import { actionType, permissionType, userType, fixedPermission } from '@/helpers/enums'
import { transformedPermissionsAPI, transformPermission } from '@/helpers/data-transform';
export default {
	data() {
		return {
			tableInput: {},
			showPassword: false,
			showConfirmPassword: false,
			deleteDialog: false,
			dialog: false,
			dialogPower: false,
			rules,
			userId: null,
			userIdDelete: null,
			userActivatedId: null,
			submitData: {
				name: null,
				username: null,
				password: null,
				confirmPassword: null,
			},
			loading: false,
			loadingPermissions: false,
			show: false,
			userPermissions: [],
			entries: [],
			isEditItem: false,
			rowEditIndex: null,
			validationMessages: [],
			userType,
			userTypes: [
				{ id: userType.casher, name: this.$t('Users.casher') },
				{ id: userType.manager, name: this.$t('Users.executive-director') },
				{ id: userType.dataReader, name: this.$t('Users.viewer') },
			],

			// permissions
			permissionsDialog: false,
			permissionStoreIndex: null,
			actionType,

			// data
			users: [],
		}
	},
	watch: {
		dialogPower(val) {
			if (val === true) {
				if (this.userId) {
					this.submitData.name = this.getUserById(this.userId).name
					this.submitData.username = this.getUserById(this.userId).username
					this.submitData.password = this.getUserById(this.userId).password
				} else {
					this.submitData.name = null
					this.submitData.username = null
					this.submitData.password = null
					this.submitData.confirmPassword = null
				}
			} else {
				this.userId = null
				this.$refs.form.resetValidation()
				this.entries = [];
				this.$refs.form.reset();
				this.$refs.table?.resetEdit();
				this.$refs.table.resetInputs();
			}
		},

		permissionsDialog(val) {
			if (!val) this.permissionStoreIndex = null;
		}
	},
	computed: {	
		...mapState({
			stores: state => state.stores.stores,
			cashboxes: state => state.cashboxes.cashboxes,
			cashboxSystem: state => state.cashboxes.cashboxSystem,
			permissionsForUser: state => state.auth.permissionsForUser,
			selfPermissions: state => state.auth.selfPermissions,
		}),
		...mapGetters({
			getUserById: 'users/getUserById',
			getStoreById: 'stores/getStoreById',
			getCashboxById: 'cashboxes/getCashboxSystemById'
		}),
		headers() {
			const headers = [
				{
					text: '#',
					name: '#',
					value: 'id',
					setValueExpr: (val, index) => index + 1,
					columnClass: 'px-2'
				},
				{
					text: this.$t('headers.name'),
					name: 'name',
					value: 'name',
					columnClass: 'px-2'
				},
				{
					text: this.$t('headers.user-name'),
					name: 'username',
					value: 'username',
					columnClass: 'px-2'
				},
				{
					text: this.$t('headers.status-account'),
					name: 'isActive',
					value: 'isActive',
					columnClass: 'px-2'
				},
				{
					text: this.$t('headers.permissions'),
					name: 'permissions',
					value: 'permissions',
					width: '40%',
					columnClass: 'px-2'
				},
				!this.isReadonly
					? {
						text: '',
						name: 'actions',
						value: 'actions',
						columnClass: 'px-2'
					}
					: null
			].filter(Boolean)
			return headers
		},
		headersSmart() {
			const headersSmart = [
				{
					text: this.$t('Users.store-name'),
					name: 'storeId',
					value: 'storeId',
					setValueExpr: val => this.getStoreById(val)?.name,
					class: 'text-caption'
				},
				{
					text: this.$t('Users.power-type'),
					name: 'userType',
					value: 'userType',
					setValueExpr: val => this.powersArray.find(e => e.id === val)?.name,
					inputRules: this.tableInput.storeId ? rules.requiredAsNumber : [],
					class: 'text-caption'
				},
				{
					text: this.$t('forms.cashbox'),
					name: 'cashboxId',
					value: 'cashboxId',
					setValueExpr: val => this.getCashboxById(val)?.name,
					inputRules: this.tableInput.userType === userType.casher ? rules.required : [],
					class: 'text-caption'
				},
				{
					text: '',
					name: 'actions',
					value: 'actions',
					noInput: true,
				}
			];
			for (let i = 0; i < headersSmart.length; i++) {
				headersSmart[i].columnClass = (headersSmart[i].columnClass ? ' ' : '') + 'px-2';
			}
			return headersSmart
		},
		powersArray() {
			const powersArray = [
				{
					name: this.$t('Users.casher'),
					id: userType.casher
				}, 
				{
					name: this.$t('Users.executive-director'),
					id: userType.manager
				},
				{
					name: this.$t('Users.viewer'),
					id: userType.dataReader
				}
			]
			return powersArray
		},

		permissions() {
			return [
				{
					name: this.$t('Users.permissionTypes.stores'),
					permissionType: permissionType.stores,
				},
				{
					name: this.$t('Users.permissionTypes.configs'),
					permissionType: permissionType.configs,
				},
				{
					name: this.$t('Users.permissionTypes.users'),
					permissionType: permissionType.users,
				},
				{
					name: this.$t('Users.permissionTypes.item-tree'),
					permissionType: permissionType.itemTree,
				},
				{
					name: this.$t('Users.permissionTypes.account-tree'),
					permissionType: permissionType.accountTree,
				},
				{
					name: this.$t('Users.permissionTypes.account-statement'),
					permissionType: permissionType.accountStatement,
				},
				{
					name: this.$t('Users.permissionTypes.all-invoices'),
					permissionType: permissionType.allInvoices,
				},
				{
					name: this.$t('Users.permissionTypes.sale-invoice'),
					permissionType: permissionType.saleInvoice,
				},
				{
					name: this.$t('Users.permissionTypes.invoice-discount'),
					permissionType: permissionType.invoiceDiscount,
					noReadonly: true,
				},
				{
					name: this.$t('Users.permissionTypes.invoice-entries-discount'),
					permissionType: permissionType.invoiceEntriesDiscount,
					noReadonly: true,
				},
				{
					name: this.$t('Users.permissionTypes.invoice-change-account'),
					permissionType: permissionType.invoiceChangeAccount,
					noReadonly: true,
				},
				{
					name: this.$t('Users.permissionTypes.invoice-card'),
					permissionType: permissionType.invoiceCredit,
					noReadonly: true,
				},
				{
					name: this.$t('Users.permissionTypes.invoice-internal'),
					permissionType: permissionType.invoiceInternal,
					noReadonly: true,
				},
				{
					name: this.$t('Users.permissionTypes.invoice-debt'),
					permissionType: permissionType.invoiceDebt,
					noReadonly: true,
				},
				{
					name: this.$t('Users.permissionTypes.buy-invoice'),
					permissionType: permissionType.buyInvoice,
				},
				{
					name: this.$t('Users.permissionTypes.sale-refund-invoice'),
					permissionType: permissionType.saleRefundInvoice,
				},
				{
					name: this.$t('Users.permissionTypes.all-cash-journal'),
					permissionType: permissionType.allCashJournal,
				},
				{
					name: this.$t('Users.permissionTypes.cash-journal'),
					permissionType: permissionType.cashJournal,
				},
				{
					name: this.$t('Users.permissionTypes.closed-cash-journal'),
					permissionType: permissionType.closedCashJournal,
				},
				{
					name: this.$t('Users.permissionTypes.close-cash-journal'),
					permissionType: permissionType.closeJournal,
					noReadonly: true,
				},
				{
					name: this.$t('Users.permissionTypes.detailed-day'),
					permissionType: permissionType.detailedDay,
				},
				{
					name: this.$t('Users.permissionTypes.all-item-journals'),
					permissionType: permissionType.allItemJournals,
				},
				{
					name: this.$t('Users.permissionTypes.items-journal'),
					permissionType: permissionType.itemJournal,
				},
				{
					name: this.$t('Users.permissionTypes.item-statement'),
					permissionType: permissionType.itemStatement,
				},
				{
					name: this.$t('Users.permissionTypes.inventory-report'),
					permissionType: permissionType.inventoryReport,
				},
				{
					name: this.$t('Users.permissionTypes.daily-table'),
					permissionType: permissionType.dailyTable,
				},
				{
					name: this.$t('Users.permissionTypes.reports'),
					permissionType: permissionType.reports,
				},
			]
		},

		noReadonlyPermissions() {
			return this.permissions.filter(c => c.noReadonly).map(c => c.permissionType)
		},

		isReadonly() {
			return this.permissionsForUser.userType === userType.dataReader || 
				this.selfPermissions.users.isReadonly
		}
	},
	methods: {
		fetchAll(isFirstLoad = false) {
			this.loading = true
			return this.$store.dispatch('users/fetchAllWithPermission').then(data => {
				this.users = data.map(c => ({ ...c.user, permissions: c.permissions }))
			}).finally(() => {
				if (!isFirstLoad) this.loading = false
			})
		},
		submit() {
			const actionName = this.userId !== null ? 'update' : 'create';
			if (this.$refs.form.validate()) {
				this.loading = true
				Promise.all([
					this.$store.dispatch(`users/${actionName}`, {
						id: this.userId ? this.userId : null, 
						name: this.submitData.name,
						username: this.submitData.username, 
						password: this.submitData.password, 
						confirmPassword: this.submitData.confirmPassword
					}).then((data) => {
						this.$eventBus.$emit('show-snackbar', false, actionName === 'create' ? this.$t('Users.the-user-has-been-added-successfully') : this.$t('Users.user-data-has-been-modified-successfully'));
						
						if (actionName === 'create') {
							this.updateUserPermission(data)
						} else {
							this.updateUserPermission(this.userId)
						}
						
						this.fetchAll()
						this.dialogPower = false
					}).catch((e) => {
						this.message = e.response.data.message;
						this.$eventBus.$emit('show-snackbar', true, this.message);
					}).finally(() => {
						this.loading = false
					}),
				])	
			}
		}, 
		accountStatusChange() {
			this.loading = true
			const actionName = this.getUserById(this.userActivatedId).isActive === true ? 'deactivate' : 'activate'
			this.$store.dispatch(`users/${actionName}`, { id: this.userActivatedId }).finally(() => {
				this.fetchAll()
				this.loading = false
				this.dialog = false
			})
		},

		addItem() {
			if (this.$refs.table.validate()) {
				this.entries.push({
					...this.tableInput,
					permissions: this.permissions.map(c => ({
						permissionType: c.permissionType,
						value: 0,
					})) || []
				})
				this.$nextTick(() => {
					this.resetTableInputs();
					this.$refs.table.resetInputsFocus();
				})
			}
		},

		editItem() {
			if (this.$refs.table.validate()) {
				this.entries[this.rowEditIndex].storeId = this.tableInput.storeId
				this.entries[this.rowEditIndex].userType = this.tableInput.userType
				this.entries[this.rowEditIndex].cashboxId = this.tableInput.cashboxId;
				this.$refs.table.resetEdit();
				this.isEditItem = false;
				
				this.$nextTick(() => {
					this.resetTableInputs();
					this.$refs.table.resetInputsFocus();
				})
			}
		},

		resetTableInputs() {
			this.$refs.table.resetInputs({
				storeId: null,
				userType: '1',
				cashboxId: null
			})
		},

		setRowIndex(rowData) {
			this.rowEditIndex = rowData.index;
			this.isEditItem = true;
			this.$nextTick(() => {
				// this.$refs.table.resetInputsFocus();
			})
		},

		deleteItem({ index }) {
			this.$refs.table.resetEdit();
			this.isEditItem = false;
			this.entries.splice(index, 1);
			
			this.$nextTick(() => {
				this.resetTableInputs();
				this.$refs.table.resetInputsFocus();
			})
		},

		updateUserPermission(id) {
			this.$store.dispatch('users/updateUserRole', { 
				id: id,
				permissions: this.entries.map(c => ({
					cashboxId: c.cashboxId,
					storeId: c.storeId,
					userType: c.userType,
					rules: transformedPermissionsAPI([
						...c.permissions,

						// making fixed permissions in "read and write" permission
						...fixedPermission.map(c => ({
							permissionType: c.permissionType,
							value: actionType.readAndWrite,
						}))
					])
				}))
			}).then(() => {
				this.fetchAll()
			}).catch((e) => {
				this.message = e.response.data.message;
				this.$eventBus.$emit('show-snackbar', true, this.message);
			})
		},
		fetchUserPermissions(userId) {
			this.loadingPermissions = true;
			this.entries = []
			this.$store.dispatch('stores/fetchAll', {})
			this.$store.dispatch('users/fetchUserRole', { 
				id: userId
			}).then((data) => {
				this.entries = data.map(c => ({
					storeId: c.permission.storeId,
					cashboxId: c.permission.cashboxId,
					userType: c.permission.userType,
					permissions: transformPermission(c.rules, this.permissions)
				}))
			}).finally(() => {
				this.loadingPermissions = false
			})
		},

		setAllPermissionsValue(value, permissionStoreIndex) {
			for (let i = 0; i < this.entries[permissionStoreIndex].permissions.length; i++) {
				if (
					this.noReadonlyPermissions.includes(
						this.entries[permissionStoreIndex].permissions[i].permissionType
					)
				) {
					this.entries[permissionStoreIndex].permissions[i].value = 
						[actionType.read, actionType.readAndWrite].includes(value)
							? actionType.readAndWrite
							: actionType.none;
				} else {
					this.entries[permissionStoreIndex].permissions[i].value = value;
				}
			}
		},
	},
	created() {
		this.loading = true;
		Promise.all([
			this.fetchAll(),
			this.$store.dispatch('cashboxes/fetchCashboxSystem'),
			!this.stores.length ? this.$store.dispatch('stores/fetchAll') : null
		]).finally(() => {
			this.loading = false;
		})
	},
	metaInfo() {
		return {
			title: this.$t('routes.users'),
			titleTemplate: '%s | POS'
		}
	}
}
</script>

<style lang="scss">
#users {
	.v-slide-group__content {
		padding: 0;
	}
}
#app .permissions-dialog {
	.v-input--checkbox .v-input__slot {
		justify-content: center;
	}
	.permission-toggle {
		cursor: pointer;
		&:hover {
			background-color: #eee;
		}
	}
}
</style>